import { render, staticRenderFns } from "./OrderApproval.vue?vue&type=template&id=04247d06&scoped=true&"
import script from "./OrderApproval.vue?vue&type=script&lang=js&"
export * from "./OrderApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04247d06",
  null
  
)

export default component.exports